import FloatingDropdownWithArrow from "../../../sharedPages/CommonComponents/FloatingDropdownWithArrow/FloatingDropdownWithArrow";
import FloatingDropdownWithIcon from "../../../sharedPages/CommonComponents/FloatingDropdownWithIcon/FloatingDropdownWithIcon";
import "./VerifySpecificTrade.css";
import { useEffect, useState } from "react";
import useApi from "../../../../helpers/apiHelper/requestHelper";
import BubbleSvgButton from "../../../sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import { toastify } from "../../../../helpers/toast/toastify";
import { useDispatch, useSelector } from "react-redux";
import ExchangeConnectionModal from "../../../sharedPages/ExchangeConnectionModal";



const options = ["Live Trade", "Closed Trades"];
const marketOptions = ["Futures", "Spot"];

const getMarketTypeParam = (marketLabel) =>
  marketLabel === "Spot" ? "spot" : "futures";

const VerifySpecificTrade = ({
  selectedOptionForOtp,
  setSelectedOptionForOtp,
  selectedLiveTrades,
  setSelectedLiveTrades,
  setClientSecret,
  setSelectedRowsForStatsCalculation

}) => {
  const [searchParams] = useSearchParams(); //search params
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [openPosition, setOpenPosition] = useState([]);
  const [closedTrades, setClosedTrades] = useState([]);
  const [hasPreselected, setHasPreselected] = useState(false);
  const sessionId = searchParams.get("session_id");
  const [filtertradeId, setFilterTradeId] = useState(null);
  
  const [filterTime, setFilterTime] = useState(null);
  const [selectedMarket, setSelectedMarket] = useState(
    location.state?.marketType === "spot" ? "Spot" : "Futures"
  );
  const user = useSelector((state) => state.user.user);
  const [displayWarningModal, setDisplayWarningModal] = useState(false);
   
  const api = useApi();
  const dispatch = useDispatch();
  const callApi = async () => {
    setLoading(true);
    const marketType = getMarketTypeParam(selectedMarket);
    const response = await api(
      "post",
      `livetrade/getLiveTrade?marketType=${marketType}`
    );

    if (response?.data) {
      const data = response.data;
      const openPositions = data?.[0]?.openPositions || [];
      const updatedtrades = openPositions.map((el) => {
        if (el.symbol.includes("USDT")) {
          el.symbol = `${el.symbol.split("USDT")[0]}/USDT`;
        }
        return el;
      });
      updatedtrades.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
      setOpenPosition(updatedtrades);
      if (location.state?.updateTime) {
        const filterData = updatedtrades.filter(
          (el) => el.updateTime === location.state?.updateTime
        );
        // setFilterTradeId(filterData[0]._id);
        if (filterData[0]) {
          setFilterTime(filterData[0].updateTime);
          setSelectedLiveTrades(filterData);
        }
      }
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    } else {
      setOpenPosition([]);
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  };

  const fetchClosedTrades = async () => {
    setLoading(true);
    const marketType = getMarketTypeParam(selectedMarket);
    const response = await api(
      "post",
      `binanceCredentials/userTrades?marketType=${marketType}`
    );
    
    if (response?.data) {
      const updatedtrades = response?.data?.trades.map((el) => {
        if (el.pair.includes("USDT")) {
          el.pair = `${el.pair.split("USDT")[0]}/USDT`;
        }
        return el;
      });
      updatedtrades.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
      setClosedTrades(updatedtrades);
      if (location.state?.tradeId) {
        const filterData = updatedtrades.filter(
          (el) => el._id === location.state?.tradeId
        );
        if (filterData[0]) {
          setFilterTradeId(filterData[0]._id);
          setSelectedLiveTrades(filterData);
        }
      }
    } else {
      setClosedTrades([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (!selectedLiveTrades.length) {
      setSelectedLiveTrades([]);
    }
    if (selectedOptionForOtp === "Live Trade") {
      callApi();
    } else if (selectedOptionForOtp === "Closed Trades") {
      fetchClosedTrades();
    } else {
      setOpenPosition([]);
      setClosedTrades([]);
    }
  }, [selectedOptionForOtp, selectedMarket]);

  useEffect(() => {
    // Preselect logic if coming from Verify It
    if (
      !hasPreselected &&
      location.state &&
      location.state.fromVerifyIt &&
      location.state.tradeType
    ) {
      if (location.state.marketType === "spot") {
        setSelectedMarket("Spot");
      } else if (location.state.marketType === "futures") {
        setSelectedMarket("Futures");
      }
      setSelectedOptionForOtp(location.state.tradeType);
      setHasPreselected(true);
    }
  }, [location.state, hasPreselected, setSelectedOptionForOtp]);

  useEffect(() => {
    if (
      location.state &&
      location.state.fromVerifyIt &&
      location.state.tradeType &&
      hasPreselected
    ) {
      if (
        location.state.tradeType === "Live Trade" &&
        openPosition.length > 0 &&
        location.state.tradeSymbol
      ) {
        const found = openPosition.find(
          (pos) => pos.symbol === location.state.tradeSymbol
        );
        if (found) {
          setSelectedLiveTrades([
            {
              ...found,
              label: found.symbol,
              key: found.id || found.symbol,
              checked: true,
            },
          ]);
        }
      } else if (
        location.state.tradeType === "Closed Trades" &&
        closedTrades.length > 0 &&
        location.state.tradeId
      ) {
        const found = closedTrades.find(
          (trade) => trade._id === location.state.tradeId
        );
        if (found) {
          setSelectedLiveTrades([
            {
              ...found,
              label: found.pair || found.asset,
              key: found._id,
              checked: true,
            },
          ]);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openPosition, closedTrades, location.state, hasPreselected]);
  // Example dummy open positions
  // const openPositions = [
  //   {
  //     id: "pos1",
  //     symbol: "BTCUSDT",
  //     pnl: 120.5, // profit/loss in $
  //     pnlPercentage: 2.5, // percentage gain/loss
  //     entryPrice: 27000,
  //     currentPrice: 27650,
  //     size: 0.01,
  //   },
  //   {
  //     id: "pos2",
  //     symbol: "ETHUSDT",
  //     pnl: -45.2,
  //     pnlPercentage: -1.8,
  //     entryPrice: 1850,
  //     currentPrice: 1817,
  //     size: 0.5,
  //   },
  // ];

  // // Example dummy closed trades
  // const closedTradess = [
  //   {
  //     orderId: "trade1",
  //     pair: "BTCUSDT",
  //     pnl: 250,
  //     pnlPercentage: 5.2,
  //     entryPrice: 26000,
  //     exitPrice: 27350,
  //     size: 0.02,
  //     closedAt: "2025-09-24T12:30:00Z",
  //   },
  //   {
  //     orderId: "trade2",
  //     pair: "ETHUSDT",
  //     pnl: -60,
  //     pnlPercentage: -3.0,
  //     entryPrice: 1900,
  //     exitPrice: 1843,
  //     size: 0.3,
  //     closedAt: "2025-09-24T13:00:00Z",
  //   },
  // ];

  const tradeOptions =
    selectedOptionForOtp === "Live Trade"
      ? openPosition.map((pos) => ({
          ...pos,
          label: pos.symbol,
          key: pos.id || pos.symbol,
          checked: false,
          pnl: pos.pnl,
          pnlPercentage: pos.pnlPercentage,
        }))
      : closedTrades.map((trade) => ({
          ...trade,
          label: trade.pair,
          key: trade.orderId || trade.pair,
          checked: false,
        }));

  const handleDropdownClose = async (selected) => {
    try {
      setSelectedRowsForStatsCalculation(selected);
    } catch (err) {
      console.error("Error:", err);
      toastify("Payment failed. Please try again.");
    }
  };

  const handlePay = async () => {
    try {
      const res = await api("post", "users/verifyTradePaymentOneTime", {
        quantity: selectedLiveTrades?.length || 0,
      });

      if (res?.status && res?.data?.clientSecret) {
        setClientSecret(res.data.clientSecret);
      } else {
        toastify(res?.message || "Failed to create session");
      }
    } catch (err) {
      console.error("Error:", err);
      toastify("Payment failed. Please try again.");
    }
  };

  useEffect(() => {
    return () => {
      setClosedTrades([]);
      setOpenPosition([]);
    };
  }, []);

  return (
    <>
      <div
        className={`VerifiedSpecificTrading ${
          user?.leaderCommunity ? "communityVerifiedSpecificTrading" : ""
        }`}
      >
        <div className="row">
          <div className="col-lg-6 col-md-7 col-12">
            <h2 className="title">Verify Trade(s)</h2>
            <p className="subTitle">Select the trade(s) you want to verify</p>
          </div>

          <div className="col-lg-6 col-md-5 col-12"></div>
        </div>

        <div className="row" style={{ rowGap: "16px" }}>
          <div className="col-xl-3 col-lg-4 col-md-6 col-12">
            <div className={`fixedWidth1440  ${"activeFadeText"}`}>
              <FloatingDropdownWithArrow
                id="market-type"
                label="Select market"
                options={marketOptions}
                selectedValue={selectedMarket}
                setSelectedValue={(value) => {
                  setSelectedMarket(value);
                  setSelectedLiveTrades([]);
                  setFilterTime(null);
                  setFilterTradeId(null);
                }}
                bgWhite={true}
                disabled={
                  location.state &&
                  location.state.fromVerifyIt &&
                  location.state.tradeType
                }
                onSelectedBgTrue={true}
              />
            </div>
          </div>
          <div className="col-xl-3 col-lg-4 col-md-6 col-12">
            <div className={`fixedWidth1440  ${"activeFadeText"}`}>
              <FloatingDropdownWithArrow
                id="otp"
                label="Select trade type"
                options={options}
                selectedValue={selectedOptionForOtp}
                setSelectedValue={(value)=>{
                  setSelectedOptionForOtp(value);
                  setSelectedLiveTrades([]);
                }}
                bgWhite={true}
                disabled={
                  location.state &&
                  location.state.fromVerifyIt &&
                  location.state.tradeType
                }
                setDisplayWarningModal={setDisplayWarningModal}
                onSelectedBgTrue={true}
              />
            </div>
          </div>
          {selectedOptionForOtp && (
            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
              <div className={`fixedWidth1440 mx-auto`}>
                <FloatingDropdownWithIcon
                  id="inactivity"
                  label={
                    selectedOptionForOtp === "Live Trade"
                      ? "Select Live Trades"
                      : "Select Closed Trades"
                  }
                  options={tradeOptions}
                  selectedValues={selectedLiveTrades}
                  setSelectedValues={setSelectedLiveTrades}
                  onDropdownClose={handleDropdownClose}
                  disabled={
                    !tradeOptions?.length ||
                    (location.state &&
                      location.state.fromVerifyIt &&
                      location.state.tradeType)
                  }
                  filterTime={filterTime}
                  filtertradeId={filtertradeId}
                  displayArrow={true}
                  bgWhite={true}
                  onSelectedBgTrue={true}
                />
                {selectedLiveTrades.length > 1 && (
                  <div
                    className="selectedOptions"
                    style={{ paddingLeft: "18px" }}
                  >
                    <span>
                      {selectedLiveTrades
                        .map((t) => t.pair || t.symbol)
                        .join(", ")}
                    </span>
                  </div>
                )}
              </div>
            </div>
          )}
          {selectedLiveTrades.length > 0 && (
            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
              <div className="row justify-content-end">
                <div className="col-12">
                  <div className="fixedWidth1440 ms-auto">
                    <div className="verifyTradesBtn">
                      <BubbleSvgButton
                        text={`Pay $${selectedLiveTrades?.length} to Verify`}
                        type="button"
                        className="payToVerifyBtn"
                        variant={`${
                          user?.leaderCommunity ? "darkGreen" : "black"
                        }`}
                        onClick={handlePay}
                        disabled={loading}
                        isLoading={loading}
                        containerStyling={{
                          justifyContent: "center",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      {displayWarningModal && (
        <ExchangeConnectionModal
          setDisplayWarningModal={setDisplayWarningModal}
        />
      )}
      
      </div>
    </>
  );
};

export default VerifySpecificTrade;
